import { t } from "@lingui/macro";
import { LinkedinLogoIcon, XLogoIcon } from "@phosphor-icons/react";
import { Button } from "@reactive-resume/ui";
import { cn } from "@reactive-resume/utils";

type Props = {
  message: string;
  title: string;
  url: string;
  className?: string;
};

export const ToolShareButtons = ({ message, title, url, className }: Props) => {
  const xUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(message)}`;
  const linkedInUrl =
    `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}` +
    `&title=${encodeURIComponent(title)}&summary=${encodeURIComponent(message)}`;

  return (
    <div className={cn("flex flex-wrap gap-3", className)}>
      <Button asChild variant="outline" className="w-full sm:w-auto">
        <a href={xUrl} target="_blank" rel="noreferrer">
          <XLogoIcon className="mr-2" size={18} />
          {t`Share on X`}
        </a>
      </Button>

      <Button asChild variant="outline" className="w-full sm:w-auto">
        <a href={linkedInUrl} target="_blank" rel="noreferrer">
          <LinkedinLogoIcon className="mr-2" size={18} />
          {t`Share on LinkedIn`}
        </a>
      </Button>
    </div>
  );
};
